import React, { useState } from 'react';
import CustomNavbar from '../../components/navbar';
import Sidebar from '../../components/sidebar';
import MainContent from '../../components/mainContent';
//import '../../style/dashboard.css'; // Estilos gerais
import DynamicForm from '../../pages/Painel/avaliacao';

const Index = () => {

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="dashboard-container">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} />

      {/* Área de conteúdo */}
      <div className={`main-area ${isSidebarOpen ? 'sidebar-open' : ''}`}>
        {/* Navbar */}
        <CustomNavbar toggleSidebar={toggleSidebar} />

        {/* Conteúdo principal */}
        <MainContent>
          {/* Aqui você pode adicionar o componente DynamicForm */}
          <DynamicForm />
        </MainContent>
      </div>
    </div>
  );
};

export default Index;
